import { useTranslation } from "../i18n";

function Invitation() {
  const { t } = useTranslation();

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginLeft: "1rem",
    marginRight: "1rem",
    marginTop: "8rem",
  };

  const blockStyle = {
    fontFamily: "var(--font-montserrat)",
    fontWeight: "400",
    fontSize: "1.5rem",
    color: "var(--text-dark)",
    margin: "0 0 1rem 0",
    lineHeight: "1.4",
    textAlign: "right",
  };

  const italicStyle = {
    fontFamily: "var(--font-montserrat)",
    fontWeight: "400",
    fontSize: "1.5rem",
    color: "var(--text-dark)",
    fontStyle: "italic",
  };

  return (
    <div style={containerStyle}>
      <div style={blockStyle} dangerouslySetInnerHTML={{ __html: t('invitation.civil') }} />
      <div style={blockStyle} dangerouslySetInnerHTML={{ __html: t('invitation.anschliessend') }} />
      <div style={blockStyle} dangerouslySetInnerHTML={{ __html: t('invitation.gefeiert') }} />
      <div style={blockStyle} dangerouslySetInnerHTML={{ __html: t('invitation.freuen') }} />
    </div>
  );
}

export default Invitation;
